InputView = require("views/input")

class VideoContributionView extends InputView
  template: require("./template")

  generateUUID: ->
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace /[xy]/g, (c) ->
      r = Math.random() * 16 | 0
      v = if c is 'x' then r else (r & 0x3 | 0x8)
      v.toString(16)

  initialize: (options) ->
    @uploadConfiguration = options.lessonConfiguration.upload
    @uploadUUID = @generateUUID()
    super

  events: ->
    "iostap .btn-done": "nextSlide"

  serialize: ->
    data = super
    data.title = @options.data.question.content
    data

  show: ->
    @setEl @findOne(".upload-video"), "button"
    @setEl @findOne(".upload-progress-bar"), "progress-bar"
    @createUploader()

  createUploader: ->
    configuration = window.__?.uploadConfiguration or @uploadConfiguration

    @setState "prompt", "upload"

    uploader = new qq.s3.FineUploaderBasic _.extend
      debug: true
      chunking:
        enabled: true
        concurrent: enabled: true
      resume:
        enabled: true
      retry:
        enableAuto: true
      camera:
        ios: true
      validation:
        acceptFiles: "video/*"
      button: @getEl("button")
      objectProperties:
        key: (id) =>
          name      = uploader.getName(id)
          extension = if ext = name.match(/[^\.]+$/) then ext[0] else "mp4"
          "contributions/#{@uploadUUID}.#{extension}"
      callbacks:
        onUpload: _.bind(@onUpload, this)
        onStatusChange: _.bind(@onStatusChange, this)
        onError: _.bind(@onError, this)
        onComplete: _.bind(@onComplete, this)
        onProgress: _.bind(@onProgress, this)

    , configuration

  onUpload: ->
    @setState("in-progress", "upload")
    @transform @getEl("progress-bar"),
      scale: "0, 1",
      transition: "none"

  onStatusChange: console.log

  onError: (id, name, reason) ->
    @setState("prompt")
    @setState("error", "upload")

  onComplete: (id, name, response) ->
    @uploadedFileKey = response.uploadKey
    @setState("touched")
    @setState("complete", "upload")
    @transform @getEl("progress-bar"), scale: "1, 1"

  onProgress: (id, name, uploadedBytes, totalBytes) ->
    @transform @getEl("progress-bar"),
      scale: "#{uploadedBytes / totalBytes * 0.7}, 1",
      transition: "all 300ms"

  userInput: ->
    contribution:
      video: @uploadedFileKey
      question:
        content: @options.data.question.content
        id: @options.data.question.id


module.exports = VideoContributionView
